var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-1"},[_c('dropdown',{class:['w-100'],attrs:{"variant":"standard btn-change-status","title":"Manejar Estatus","items":_vm.statuses.map(x => ({
        label: x.description,
        click: () => _vm.setCurrentStatusTarget(x)
      })),"icon":"fas fa-exchange"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }